import { Form, Checkbox, Col, Row } from 'antd';
import FloatingFormItem from '../../FloatingFormItem';
import InputDecimal from '../../InputDecimal';
import SectionCard from '../../SectionCard';
import SelectInvoiceClassificationTax from '../SelectInvoiceClassificationTax';
import SelectInvoiceCST from '../SelectInvoiceCST';

interface Props {
  prefixPath?: string[];
}

export default function RegularTaxationFormFields({
  prefixPath = ['itemTaxes', 'ibsCbs'],
}: Props) {
  const form = Form.useFormInstance();
  const enableTribRegular = Form.useWatch('enableTribRegular', form);
  const regularTaxIbsCbsCst = Form.useWatch(
    [...prefixPath, 'regularTaxIbsCbsCst'],
    form,
  );

  return (
    <>
      {/* ===== Tributação Regular (UB68..UB72d) ===== */}
      <div>
        <Form.Item name="enableTribRegular" valuePropName="checked">
          <Checkbox style={{ fontWeight: 600 }}>
            Exibir Grupo de Tributação Regular
          </Checkbox>
        </Form.Item>
      </div>

      <SectionCard
        visible={enableTribRegular}
        title="Tributação Regular"
        subtitle="Campos de simulação conforme NT"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} sm={12}>
            <FloatingFormItem
              label="CST (IBS/CBS)"
              name={[...prefixPath, 'regularTaxIbsCbsCst']}
              getValueFromEvent={(value) => {
                form.setFieldValue(
                  [...prefixPath, 'regularTaxIbsCbsClassificationCode'],
                  undefined,
                );
                return value;
              }}
            >
              <SelectInvoiceCST
                queryParams={{ cstType: 'IBS_CBS' }}
                allowClear
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12}>
            <FloatingFormItem
              label="Classificação Tributária (IBS/CBS)"
              name={[...prefixPath, 'regularTaxIbsCbsClassificationCode']}
            >
              <SelectInvoiceClassificationTax
                queryParams={{
                  classificationType: 'IBS_CBS',
                  cstCode: regularTaxIbsCbsCst,
                }}
                allowClear
              />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor da alíquota IBS-UF (%)"
              name={[...prefixPath, 'regularTaxIbsUfAliquotPercentage']}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor do Tributo IBS-UF"
              name={[...prefixPath, 'regularTaxIbsUfValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor da alíquota IBS-Mun (%)"
              name={[...prefixPath, 'regularTaxIbsMunicipalAliquotPercentage']}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor do Tributo IBS-Mun"
              name={[...prefixPath, 'regularTaxIbsMunicipalValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor da alíquota CBS (%)"
              name={[...prefixPath, 'regularTaxCbsAliquotPercentage']}
            >
              <InputDecimal fractions={4} />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} md={6}>
            <FloatingFormItem
              label="Valor do Tributo CBS"
              name={[...prefixPath, 'regularTaxCbsValue']}
            >
              <InputDecimal />
            </FloatingFormItem>
          </Col>
        </Row>
      </SectionCard>
    </>
  );
}
